<template>
  <div class="height100-percent">
    <div class="table-page-search-wrapper bg-white">
      <a-form-model
        ref="fnForm"
        :model="baseInfo"
        :rules="rules"
        layout="inline"
        :labelCol="{ style: { width: '100px' } }"
      >
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-model-item label="发货预测名称" prop="shipmentForecastName">
              <a-input @input="baseInfo.shipmentForecastName = $event.target.value.replace(/\//g, '')" v-model="baseInfo.shipmentForecastName" />
            </a-form-model-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-model-item label="版本" prop="shipmentForecastVersion">
              <a-input :disabled="true" v-model="baseInfo.shipmentForecastVersion" />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24"> </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-tabs
      :activeKey="activeTab"
      default-active-key="1"
      @change="tabsCallback"
      class="bg-white height100-percent mt5"
    >
      <a-tab-pane key="1" tab="基础信息">
        <div class="table-page-search-wrapper bg-white mr16">
          <a-form-model
            ref="basicForm"
            :model="baseInfo"
            :rules="basicRules"
            layout="inline"
            :labelCol="{ style: { width: '160px' } }"
          >
            <a-row>
              <a-col class="form-title" :md="24" :sm="24">
                <span class="form-title">计划期间</span>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="当前期间" prop="currentPeriod">
                  <a-month-picker
                    class="w100-percent"
                    format="YYYY-MM"
                    valueFormat="YYYY-MM"
                    placeholder="请选择日期"
                    v-model="baseInfo.currentPeriod"
                  >
                  </a-month-picker>
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="预测期间" prop="forecastPeriodTem">
                  <a-range-picker
                    :placeholder="['开始日期', '结束日期']"
                    valueFormat="YYYY-MM"
                    format="YYYY-MM"
                    :value="baseInfo.forecastPeriodTem"
                    :mode="mode"
                    @panelChange="handlePanelChange"
                  />
                </a-form-model-item>
              </a-col>
              <!-- 第二行 -->
              <a-col class="form-title" :md="24" :sm="24">
                <span >计划参数</span>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="生产提前天数" prop="preProductionDays">
                  <a-input-number
                    class="w100-percent"
                    v-model="baseInfo.preProductionDays"
                    :min="0"
                    @change="onChange"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="信任度" prop="credibility">
                  <a-input-number class="w100-percent" v-model="baseInfo.credibility" :min="0" @change="onChange" />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="未发取消比例" prop="cancellationRatio">
                  <a-input-number
                    class="w100-percent"
                    v-model="baseInfo.cancellationRatio"
                    :min="0"
                    @change="onChange"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="当月销售目标完成占比度" prop="salesTargetRatio">
                  <a-input-number class="w100-percent" v-model="baseInfo.salesTargetRatio" :min="0" @change="onChange" />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="参数版本" prop="parameterVersion">
                  <global-select
                    :value.sync="baseInfo.parameterVersion"
                    selectType="selectAssemble"
                    :setParams="{ start: baseInfo.currentPeriod }"
                    requestApi="/scp/scpSopShipmentForecast/listBaseVersion"
                    :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
                  />
                </a-form-model-item>
              </a-col>
              <!-- 第三行 -->
              <a-col class="form-title" :md="24" :sm="24">
                <span class="form-title">计划范围</span>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="事业部" prop="demandDepartment">
                  <global-select
                    @change="handlDepartment"
                    :value.sync="baseInfo.demandDepartment"
                    selectType="select"
                    requestApi="/scp/scpSopShipmentForecast/listBusiness"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="上期预测名称和版本" prop="fcNameVersion">
                  <global-select
                    :value.sync="baseInfo.fcNameVersion"
                    selectType="select"
                    requestApi="/scp/scpSopShipmentForecast/getLastSalesForecast"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="仅汇总" prop="summaryFlag">
                  <!-- <a-select v-model="baseInfo.summaryFlag">
                     <a-select-option v-for="item in baseUomFlagOptions"
                                     :key="item.dictValue"
                    >{{ item.dictLabel }}
                    </a-select-option>
                  </a-select> -->
                  <a-switch :disabled="baseInfo.demandDepartment!=='JT'" :checked="summaryFlagChecked" checked-children="是" un-checked-children="否" @change="handleSummaryFlagChecked" />

                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="预测列表" force-render>
        <div class="table-page-operator-wrapper p8">
          <a-button @click="handleAdd" type="primary">新增</a-button>
        </div>
        <ls-table-layout class="height100-percent">
          <template v-slot:table>
            <div class="page-header-content">
              <ls-api-table
                ref="dataTable"
                :columns="columns"
                :tableProps="tableProps"
                rowKey="id"
                :scroll="{ fixScreen: true, x: 1300 }"
              >
                <span slot="inventoryOrganizationCodeTitle"> <i class="toRequired">*</i>预测类型 </span>
                <span slot="subInventoryNameTitle"> <i class="toRequired">*</i>版本信息 </span>
                <template slot="inventoryOrganizationCode" slot-scope="{ record }">
                  <global-select
                    @change="handlGselect(record, 'forecastType')"
                    class="select-table"
                    :value.sync="record.forecastType"
                    :setParams="{ summaryFlag: baseInfo.summaryFlag }"
                    selectType="select"
                    requestApi="/scp/scpSopShipmentForecast/listForecastType"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                  />
                </template>
                <template slot="inventoryOrganizationName" slot-scope="{ record }">
                  <global-select
                    @change="handlGselect(record, 'forecastName')"
                    :disabled="!record.forecastType"
                    class="select-table"
                    :value.sync="record.forecastName"
                    selectType="select"
                    requestApi="/scp/scpSopShipmentForecast/listForecastName"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                    :setParams="{ type: record.forecastType, start: baseInfo.forecastPeriodFrom, end: baseInfo.forecastPeriodTo }"
                  />
                </template>
                <template slot="subInventoryCode" slot-scope="{ record }">
                  <!-- <a-input class="select-table" v-model="record.demandDepartment" /> -->
                  <a-select v-model="record.demandDepartment">
                    <a-select-option v-for="item in businessList"
                                     :key="item.realValue"
                    >{{ item.label }}
                    </a-select-option>
                  </a-select>
                </template>
                <template slot="subInventoryName" slot-scope="{ record }">
                  <global-select
                    v-if="!orderId"
                    :disabled="!record.forecastType || !record.forecastName"
                    class="select-table"
                    :value.sync="record.listVersion"
                    selectType="selectAssembleMultiple"
                    requestApi="/scp/scpSopShipmentForecast/listForecastVersion"
                    :setParams="{ type: record.forecastType, name: record.forecastName }"
                    :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
                    :dropdown-match-select-width="false"
                  />
                  <global-select
                    v-else
                    :disabled="!record.forecastType || !record.forecastName"
                    class="select-table"
                    :value.sync="record.version"
                    selectType="selectAssemble"
                    requestApi="/scp/scpSopShipmentForecast/listForecastVersion"
                    :setParams="{ type: record.forecastType, name: record.forecastName }"
                    :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
                    :dropdown-match-select-width="false"
                  />
                </template>

                <!-- 操作 -->
                <span slot="operation" slot-scope="{ record, index }">
                  <a @click="handleDel(record, index)" class="ml10">删除</a>
                </span>
              </ls-api-table>
            </div>
          </template>
        </ls-table-layout>
      </a-tab-pane>

      <div slot="tabBarExtraContent" class="table-page-operator-wrapper toolbar bg-white">
        <!-- <a-button @click="handleSave" type="primary">保存</a-button> -->
        <a-button @click="handleComfirmAndRun" type="primary">确认并启动</a-button>
      </div>
    </a-tabs>
  </div>
</template>
<script>
import { mapState } from 'vuex'
 import moment from 'moment';
import {
  listShipmentForecast,
  createShipmentForecast,
  getLastSalesForecast,
  apiShipmentForecastById,
  apiUpdateShipmentForecast,
  apiCreateAndStartShipmentForecast,
  apiListBusiness,
  apiGetCredibility,
  apiGetCancellationRation,
  apiGetSalesTargetRation
} from '@/api/scp/shipmentForecast/shipmentForecastManagement'
import { generateLsTableResData } from '@/utils/util.js'
export default {
  // eslint-disable-next-line
  name: 'editPage',
  components: {},
  data () {
    return {
      businessList: [],
      baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
      orderId: '', // 单号Id（唯一码）
      activeTab: '1',
      rules: {
        shipmentForecastName: [{ required: true, message: '输入发货预测名称', trigger: 'submit' }]
      },
      basicRules: {
        preProductionDays: [{ required: true, message: '输入发货预测名称', trigger: 'submit' }],
        credibility: [{ required: true, message: '输入信任度', trigger: 'submit' }],
        cancellationRatio: [{ required: true, message: '输入未发取消比例', trigger: 'submit' }],
        salesTargetRatio: [{ required: true, message: '输入当月销售目标完成占比', trigger: 'submit' }],
        parameterVersion: [{ required: true, message: '输入参数版本', trigger: 'submit' }],
        demandDepartment: [{ required: true, message: '输入事业部', trigger: 'submit' }],
        fcNameVersion: [{ required: true, message: '输入上期预测和版本', trigger: 'submit' }],
        currentPeriod: [{ required: true, message: '输入当前期间', trigger: 'submit' }],
        forecastPeriodTem: [{ required: true, message: '输入预测期间', trigger: 'submit' }],
        summaryFlag: [{ required: true, message: '输入汇总', trigger: 'submit' }]
      },
      inventoryOrganizationCodeList: [], // 预测类型
      tableList: [],
      tableListObj: {
        demandDepartment: '', // 事业部
        forecastName: '', // 预测名称
        forecastType: '', // 预测类型
        listVersion: undefined, // 版本信息
        version: undefined // 版本信息

      },
      mode: ['month', 'month'],
      // 查询参数
      queryParams: {
        uomClassList: undefined
      },
      baseInfo: {
        summaryFlag: 'N',
        listSf: [],
        organizationCode: undefined,
        preProductionDays: '', // 生产天数
        credibility: '', // 信任度
        cancellationRatio: '', // 未发取消比例
        salesTargetRatio: '', // 当月销售目标完成占比
        parameterVersion: '', // 参数版本
        demandDepartment: '', // 事业部
        fcNameVersion: '', // 上期预测名称和版本
        currentPeriod: '', // 当前期间
        forecastPeriodTem: '', // 临时时间
        forecastPeriodFrom: '', // 预测期间起
        forecastPeriodTo: '', // 预测期间止
        shipmentForecastName: '' // 发货预测名称
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listShipmentForecast, true),
        pageCurrent: true
      },
      // 表格字段
      columns: [
        {
          dataIndex: 'forecastType',
          scopedSlots: { customRender: 'inventoryOrganizationCode', title: 'inventoryOrganizationCodeTitle' },
          align: 'center',
          width: 100
        },
        {
          title: '预测名称',
          dataIndex: 'forecastName',
          scopedSlots: { customRender: 'inventoryOrganizationName' },
          width: 100,
          align: 'center'
        },
        {
          title: '事业部',
          dataIndex: 'demandDepartment',
          scopedSlots: { customRender: 'subInventoryCode' },
          width: 100,
          align: 'center'
        },
        {
          width: 100,
          dataIndex: 'listVersion',
          scopedSlots: { customRender: 'subInventoryName', title: 'subInventoryNameTitle' },
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      yearMonthTem: null
    }
  },
  methods: {
    handleSummaryFlagChecked (flag) {
      flag ? this.baseInfo.summaryFlag = 'Y' : this.baseInfo.summaryFlag = 'N'
      const tableList = this.$refs.dataTable.myDataSource
      tableList.forEach(item => {
        item.forecastType = undefined; // 清空forecastType属性，将其设置为空字符串
      });
    },
    handlDepartment (val) {
      if (val !== 'JT') {
        this.baseInfo.summaryFlag = 'N'
      }
    },
    /** 加载默认的数据 */
    loadDefaultPageData () {
      this.baseInfo.preProductionDays = 2;
      apiGetCredibility().then((response) => {
        if (response.code === 200) {
          this.baseInfo.credibility = response.data
        }
      })
      const paramCancellation = { currentPeriod: this.baseInfo.currentPeriod }
      apiGetCancellationRation(paramCancellation).then((response) => {
        if (response.code === 200) {
          this.baseInfo.cancellationRatio = response.data
        }
      })
      apiGetSalesTargetRation(paramCancellation).then((response) => {
        if (response.code === 200) {
          this.baseInfo.salesTargetRatio = response.data
        }
      })
    },
    /** 加载已经保存的数据 */
    loadPageData (orderId) {
      apiShipmentForecastById(orderId).then((response) => {
        if (response.code === 200) {
          this.baseInfo = { ...this.baseInfo, ...response.data };
          this.tableList = response.data.listSfForecast
          /** 预测期间 */
          const forecastPeriodFromData = new Date(this.baseInfo.forecastPeriodFrom + "-02").toISOString();
          const forecastPeriodToData = new Date(this.baseInfo.forecastPeriodTo + "-02").toISOString();
          this.baseInfo.forecastPeriodTem = [forecastPeriodFromData, forecastPeriodToData]
          this.$refs.dataTable.myDataSource = this.tableList
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    handlGselect (record, dataIndex) {
      if (dataIndex === 'forecastType') {
        record.forecastName = ''
       // if() //放里面存在 销售预测 forecastType
      const tableList = this.$refs.dataTable.myDataSource
      const fc1Items = tableList.filter(item => item.forecastType === 'FC1');
        if (fc1Items.length > 1) {
          record.forecastType = undefined
          this.$message.error('不能存在两行销售预测')
        }
      }
      record.listVersion = undefined
      record.version = undefined
    },
    tabsCallback (val) {
      this.activeTab = val
    },
    handleDel (record, index) {
      this.tableList.splice(index, 1)
    },
    handleAdd () {
      this.tableList.push({ ...this.tableListObj })
      this.$refs.dataTable.myDataSource = this.tableList
    },
    async handleComfirmAndRun () {
      const startTime = this.baseInfo.currentPeriod
      const endTime = this.baseInfo.forecastPeriodTo

      const start = moment(startTime + '-01');
      const end = moment(endTime + '-01');

      const diffInMonths = end.diff(start, 'months');
      if (diffInMonths > 11) {
        this.$message.error('当前期间与预测期间的结束时间,间隔不能超过12个月')
        return
      }
      const promise1 = new Promise((resolve) => {
        this.$refs.fnForm.validate((valid) => {
          resolve(valid)
        })
      })

      const promise2 = new Promise((resolve) => {
        this.$refs.basicForm.validate((valid) => {
          resolve(valid)
        })
      })

      const [valid1, valid2] = await Promise.all([promise1, promise2])

      if (valid1 && valid2) {
      } else {
        this.$set(this, 'activeTab', '1')
        return ''
      }
      let flag = false
      if (this.$refs.dataTable.myDataSource.length === 0) {
        this.$message.warning('预测列表不能为空')
        flag = true
      }
      for (let i = 0; i < this.tableList.length; i++) {
        if ((!this.tableList[i].listVersion && !this.orderId) || !this.tableList[i].forecastType || (!this.tableList[i].version && this.orderId)) {
          this.$message.warning('必填项不能为空！')
          flag = true
        }
      }
      if (flag) {
        this.$set(this, 'activeTab', '2')
        return false
      }
      const self = this
      this.$confirm({
        title: '提示',
        content: '你确定确定并启动该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.comfirmAndRun()
        },
        onCancel () {
        }
      });
    },
    async comfirmAndRun () {
      this.baseInfo.listSfForecast = [...this.tableList]
      // apiCreateAndStartShipmentForecast(this.baseInfo).then((response) => {
      //   if (response.code === 200) {
      //     this.$message.success('确认启动成功')
      //     this.event.$emit("close-current-page");
      //   } else {
      //     this.$message.error(response.msg)
      //   }
      // })
            // 提交数据
      if (this.orderId) {
        apiUpdateShipmentForecast(this.baseInfo).then((response) => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.event.$emit("close-current-page");
        } else {
          this.$message.error(response.msg)
        }
      })
      } else {
        apiCreateAndStartShipmentForecast(this.baseInfo).then((response) => {
          if (response.code === 200) {
            this.$message.success('确认启动成功')
            this.event.$emit("close-current-page");
          } else {
            this.$message.error(response.msg)
          }
        })
      }
    },
    /** 保存数据到数据库 */
    async handleSave () {
      const promise1 = new Promise((resolve) => {
        this.$refs.fnForm.validate((valid) => {
          resolve(valid)
        })
      })

      const promise2 = new Promise((resolve) => {
        this.$refs.basicForm.validate((valid) => {
          resolve(valid)
        })
      })

      const [valid1, valid2] = await Promise.all([promise1, promise2])

      if (valid1 && valid2) {
      } else {
        this.$set(this, 'activeTab', '1')
        return ''
      }
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if ((!this.tableList[i].listVersion && !this.orderId) || !this.tableList[i].forecastType || (!this.tableList[i].version && this.orderId)) {
          this.$message.warning('必填项不能为空！')
          flag = true
        }
      }
      if (flag) {
        this.$set(this, 'activeTab', '2')
        return false
      }
      // 提交数据
      this.baseInfo.listSfForecast = [...this.tableList]
      if (this.orderId) {
        apiUpdateShipmentForecast(this.baseInfo).then((response) => {
        if (response.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(response.msg)
        }
      })
      } else {
        createShipmentForecast(this.baseInfo).then((response) => {
        if (response.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(response.msg)
        }
      })
      }
    },
    handlePanelChange (value, mode) {
      const yearMonth1 = value[0].format('YYYY-MM')
      let yearMonth2 = value[1].format('YYYY-MM')
      if (this.yearMonthTem !== yearMonth1) {
        const yearAfter5MonthMoment = moment(yearMonth1, 'YYYY-MM').add(4, 'months');

        const yearAfter5Month = yearAfter5MonthMoment.format('YYYY-MM');
        yearMonth2 = yearAfter5Month
        value[1] = yearAfter5MonthMoment
      }
      this.baseInfo.forecastPeriodFrom = yearMonth1
      this.baseInfo.forecastPeriodTo = yearMonth2
      this.baseInfo.forecastPeriodTem = value
      this.$refs.dataTable.myDataSource = []
      this.tableList = []
      this.yearMonthTem = yearMonth1
    },
    // 默认最新销售预测的名称和版本
    getLastSalesForecast () {
      getLastSalesForecast().then((response) => {
        if (response.code === 200) {
          this.baseInfo.fcNameVersion = response.data[0].realValue
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    getListBusiness () {
      apiListBusiness().then((response) => {
        if (response.code === 200) {
          this.businessList = response.data
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams)
        .then()
        .then((response) => {
          this[arr] = response.rows
        })
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    summaryFlagChecked () {
    return this.baseInfo.summaryFlag === 'Y';
  }
  },
  created () {
    this.baseInfo.organizationCode = this.organizationCodeOrigin
    this.getLastSalesForecast()
    this.getListBusiness()
    this.getLookupList('SOP_FORECAST_TYPE', 'inventoryOrganizationCodeList')
     const currentDate = new Date(); // 创建 Date 对象
      const futureDateTo = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate()); // 计算4个月后的日期
      const futureDateFrom = new Date(currentDate.getFullYear(), currentDate.getMonth() + 4, currentDate.getDate()); // 计算4个月后的日期

      this.baseInfo.currentPeriod = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}`
      this.baseInfo.forecastPeriodFrom = `${futureDateTo.getFullYear()}-${futureDateTo.getMonth() + 1}`
      this.baseInfo.forecastPeriodTo = `${futureDateFrom.getFullYear()}-${futureDateFrom.getMonth() + 1}`
      this.baseInfo.forecastPeriodTem = [`${this.baseInfo.forecastPeriodFrom }-01`, `${this.baseInfo.forecastPeriodTo }-01`]
      this.orderId = this.$route.params.id; // 从路由参数中获取 id 值
    if (this.orderId) {
      this.loadPageData(this.orderId)
    } else {
      this.loadDefaultPageData()
    }
    },
  mounted () {
    // this.$refs.dataTable.myDataSource = this.tableList

  }
}
</script>
<style scoped lang="less">
.bg-white {
  background-color: white;
}
.toolbar {
  padding: 8px;
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
}
.select-table {
  width: 180px;
}
a-input-number,
a-month-picker {
  width: 100%;
}
/deep/.ant-select {
  width: 100%;
}
.toRequired {
  color: #ff4949;
  padding-right: 2px;
}
.form-title{
  margin-left: 10px;
  margin-top: 15px;
}
.height100-percent {
  height: 100%
}
.mr16 {
  margin-right: 16px
}
.w100-percent {
  width: 100%;
}
.p8 {
  padding: 8px;
}
</style>
